import React from 'react'
import QuienesSomos from '../../Componentes/QuienesSomos';
import './estilos.css';

function QuienesSomosPage() {
    return (
        <div className='cont-quienesSomos-page'>
            <QuienesSomos />
        </div>
    )
}

export default QuienesSomosPage